import ValidationCodeDialogStage from './ValidationCodeDialogStage'
import Dialog from '../base/Dialog'
import { useTheme } from '@mui/material'

const ValidationCodeDialog = ({ showDialog, setShowDialog, validatingEmail }) => {
  const theme = useTheme()

  return (
    <Dialog
      showDialog={showDialog}
      setShowDialog={setShowDialog}
      disableClickOnShadeToExit
      title={`Confirm Your Email`}
      titleTypographyVariant = {'h6'}
      strokeMarginTop = {-4}
      strokeGradient = {theme.palette.dialog.strokeGradient}
      customBody = {<ValidationCodeDialogStage email={validatingEmail} />}
    />
  )
}

export default ValidationCodeDialog
